import { useEffect } from "react";

/**
 * Ensure the content element allows overflow so the map panel
 * (positioned absolutely to the right) is not clipped.
 * Also remove the right border-radius for a flush join.
 */
export function useMapContentOverflow(
	contentElement: HTMLElement | null,
	showMap: boolean,
): void {
	useEffect(() => {
		if (!contentElement || !showMap) {
			return;
		}
		const prevOverflow = contentElement.style.overflow;
		const prevBorderTopRight = contentElement.style.borderTopRightRadius;
		const prevBorderBottomRight = contentElement.style.borderBottomRightRadius;
		contentElement.style.overflow = "visible";
		contentElement.style.borderTopRightRadius = "0";
		contentElement.style.borderBottomRightRadius = "0";
		return () => {
			contentElement.style.overflow = prevOverflow;
			contentElement.style.borderTopRightRadius = prevBorderTopRight;
			contentElement.style.borderBottomRightRadius = prevBorderBottomRight;
		};
	}, [contentElement, showMap]);
}
